"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchOrdersByStoreIdAndWalletAddress = exports.fetchOrderByTokenMintAndShopId = exports.fetchOrderByTokenMint = exports.fetchOrdersByStoreId = void 0;
const qs_1 = __importDefault(require("qs"));
async function fetchOrdersByStoreId(axiosInstance, storeId, ordersFilterQuery) {
    const { sortBy, offset, limit, identifiers, sellerAddress, candyShopAddress, attribute: attributeQuery } = ordersFilterQuery;
    let attribute = undefined;
    if (attributeQuery) {
        const entries = Object.entries(attributeQuery);
        attribute = {
            trait_type: entries[0][0],
            value: entries[0][1]
        };
    }
    console.log(`CandyShop: fetching orders from ${storeId}, query=${JSON.stringify(ordersFilterQuery)}`);
    const queryObject = {};
    if (sortBy) {
        queryObject['orderByArr'] = JSON.stringify(sortBy);
    }
    if (offset) {
        queryObject['offset'] = offset;
    }
    if (limit) {
        queryObject['limit'] = limit;
    }
    let filterString = '';
    if (identifiers && identifiers.length !== 0) {
        filterString = identifiers.reduce((aggregated, identifier) => aggregated +
            `&filterArr[]=${JSON.stringify({
                side: 1,
                status: 0,
                identifier,
                walletAddress: sellerAddress,
                candyShopAddress,
                attribute // attribute is exited when having identifier
            })}`, '');
    }
    else {
        filterString = `&filterArr[]=${JSON.stringify({
            side: 1,
            status: 0,
            walletAddress: sellerAddress,
            candyShopAddress
        })}`;
    }
    let queryString = qs_1.default.stringify(queryObject);
    queryString += filterString;
    return axiosInstance.get(`/order/${storeId}?${queryString}`).then((response) => response.data);
}
exports.fetchOrdersByStoreId = fetchOrdersByStoreId;
/**
 * @deprecated The method should not be used.
 * Please use function fetchOrderByTokenMintAndShopId below
 */
async function fetchOrderByTokenMint(axiosInstance, mintAddress) {
    return axiosInstance.get(`/order/mint/${mintAddress}`).then((response) => response.data);
}
exports.fetchOrderByTokenMint = fetchOrderByTokenMint;
async function fetchOrderByTokenMintAndShopId(axiosInstance, mintAddress, shopId) {
    console.log(`CandyShop: fetching orders by shop address=${shopId}, mintAddress=${mintAddress}`);
    return axiosInstance
        .get(`/order/mint/${mintAddress}/shop/${shopId}`)
        .then((response) => response.data);
}
exports.fetchOrderByTokenMintAndShopId = fetchOrderByTokenMintAndShopId;
async function fetchOrdersByStoreIdAndWalletAddress(axiosInstance, storeId, walletAddress) {
    console.log(`CandyShop: fetching orders by shop address=${storeId}, walletAddress=${walletAddress}`);
    // handles pagination internally
    const limit = 10;
    let offset = 0;
    let resCount = null;
    let orders = [];
    while (resCount === null || resCount == limit) {
        const page = await axiosInstance
            .get(`/order/${storeId}?offset=${offset}&limit=${limit}&filterArr[]=${JSON.stringify({
            side: 1,
            status: 0,
            walletAddress
        })}`)
            .then((response) => { var _a; return (_a = response.data) === null || _a === void 0 ? void 0 : _a.result; });
        resCount = page.length;
        offset = offset + limit;
        orders = orders.concat(page);
    }
    return orders;
}
exports.fetchOrdersByStoreIdAndWalletAddress = fetchOrdersByStoreIdAndWalletAddress;
